



































import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { BlogFilter } from 'client-website-ts-library/filters';
import { BlogType, WebsiteLevel } from 'client-website-ts-library/types';

import Blogs from '../components/Blogs.vue';

@Component({
  components: {
    Blogs,
  },
})
export default class ProjectsAndDevelopments extends Mixins(View) {
  private filter = new BlogFilter({
    SearchLevel!: WebsiteLevel.Profile,
    SearchGuid!: '8a2d8aeb-2570-49ad-82cd-c53ce794baa0',
    Types!: [BlogType.Estate],
  });
}
